import styled from "styled-components";

export const Card = styled.div`
    width: 100%;
    background: #fff;
    padding: ${props => props.padding || 0};
`;
